import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { Store } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { mainRootReducer } from './mainRootReducer';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ThunkAction = (dispatch: Dispatch, getState: GetState) => any;

let store: Store;

const customizedMiddleware = getDefaultMiddleware({
  immutableCheck: false,
  serializableCheck: false,
});

// eslint-disable-next-line import/no-default-export
export default function configureMainStore(preloadedState?: State) {
  store = configureStore({
    preloadedState,
    reducer: mainRootReducer,
    middleware: customizedMiddleware,
  });

  return store;
}

export type Dispatch = typeof store.dispatch;
export type GetState = typeof store.getState;
export type State = ReturnType<Store['getState']>;
